import { render } from "./ProjectTestModeModal.vue?vue&type=template&id=6f990c0c"
import script from "./ProjectTestModeModal.vue?vue&type=script&lang=js"
export * from "./ProjectTestModeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__